import { RestClient, RequestResponse } from "./base/rest.client";
import { CommonDto } from "../common.dto";
import { BASE_URL } from "../config";
import { UploadFilesResponseSchema } from "./file.schemas";
import * as z from "zod";

export interface UploadedFile {
  file_id: string | number;
  original_filename: string;
  preview_pdf_url: string;
  pages_count: number;
  original_url?: string | null;
}

export interface UploadFilesResponse {
  status: string;
  data: {
    files: UploadedFile[];
  };
  details: string;
}

class FileClientClass extends RestClient {
  baseUrl = BASE_URL;

  /**
   * Загружает файлы на сервер
   */
  async uploadFiles(files: File[]): Promise<{ data: UploadFilesResponse }> {
    console.log("[FileClient.uploadFiles] Starting upload, files:", files.map(f => ({
      name: f.name,
      size: f.size,
      type: f.type
    })));

    const formData = new FormData();
    
    files.forEach(file => {
      console.log("[FileClient.uploadFiles] Adding file to FormData:", {
        name: file.name,
        size: file.size,
        type: file.type
      });
      formData.append("files", file);
    });

    console.log("[FileClient.uploadFiles] FormData prepared, making request to /api/files/upload");

    const result = await this.request(
      "POST",
      "/api/files/upload",
      {
        formData,
      }
    );

    const validated = this.validateResponse(result, CommonDto.withStatus(UploadFilesResponseSchema));

    console.log("[FileClient.uploadFiles] Upload successful:", {
      status: validated.status,
      dataKeys: validated.data ? Object.keys(validated.data) : [],
      filesCount: validated.data?.files?.length || 0,
    });

    // Возвращаем в формате, совместимом со старым API
    return {
      data: {
        status: validated.status,
        data: validated.data,
        details: validated.details || "",
      }
    };
  }
}

export class FileClient extends FileClientClass {}
